module.exports = __webpack_public_path__ + "static/media/990704.a48cd85a.png";